// src/components/perfil/PerfilUsuario.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';

/* ---- Ícones SVG ---- */
const ArrowLeftIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="15 18 9 12 15 6" />
    </svg>
);
const UserIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
    </svg>
);
const LockIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
);
const EyeIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" />
    </svg>
);
const EyeOffIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
        <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
);
const LogoutIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" />
    </svg>
);
const ChevronIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 12 15 18 9" />
    </svg>
);

const PERFIL_LABELS = {
    super_admin: 'Super Administrador',
    admin: 'Administrador',
    diretor: 'Diretor',
    operacional: 'Operacional',
    palestrante: 'Palestrante',
};

const PERFIL_STYLES = {
    super_admin: { color: '#7c3aed', bg: 'rgba(124,58,237,0.08)', border: 'rgba(124,58,237,0.2)' },
    admin:       { color: '#ef4444', bg: 'rgba(239,68,68,0.08)',   border: 'rgba(239,68,68,0.2)' },
    diretor:     { color: '#7c3aed', bg: 'rgba(124,58,237,0.08)',  border: 'rgba(124,58,237,0.2)' },
    operacional: { color: '#2563eb', bg: 'rgba(37,99,235,0.08)',   border: 'rgba(37,99,235,0.2)' },
    palestrante: { color: '#ea580c', bg: 'rgba(234,88,12,0.08)',   border: 'rgba(234,88,12,0.2)' },
};

const PerfilUsuario = ({ supabase, session, clienteData, onLogout }) => {
    const navigate = useNavigate();
    const toast = useToast();
    const [novaSenha, setNovaSenha] = useState('');
    const [confirmarSenha, setConfirmarSenha] = useState('');
    const [showNovaSenha, setShowNovaSenha] = useState(false);
    const [showConfirmar, setShowConfirmar] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    const metadata = session?.user?.user_metadata || {};
    const nome = metadata.nome || metadata.cliente_nome || 'Usuário';
    const emailReal = metadata.email_real || session?.user?.email || '';
    const perfil = metadata.perfil || 'operacional';
    const clienteNome = clienteData?.nome || metadata.cliente_nome || '';
    const iniciais = nome.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase();
    const perfilStyle = PERFIL_STYLES[perfil] || PERFIL_STYLES.operacional;

    const handleAlterarSenha = async (e) => {
        e.preventDefault();

        if (!novaSenha || novaSenha.length < 6) {
            toast({ title: 'A nova senha deve ter pelo menos 6 caracteres', status: 'warning', duration: 3000 });
            return;
        }
        if (novaSenha !== confirmarSenha) {
            toast({ title: 'As senhas não coincidem', status: 'error', duration: 3000 });
            return;
        }

        setIsLoading(true);
        try {
            const { error } = await supabase.auth.updateUser({ password: novaSenha });
            if (error) throw error;

            const { error: rpcError } = await supabase.rpc('atualizar_propria_senha', { p_nova_senha: novaSenha });
            if (rpcError) throw rpcError;

            toast({ title: 'Senha alterada com sucesso!', status: 'success', duration: 3000 });
            setNovaSenha('');
            setConfirmarSenha('');
        } catch (error) {
            toast({ title: 'Erro ao alterar senha', description: error.message, status: 'error', duration: 5000 });
        } finally {
            setIsLoading(false);
        }
    };

    const handleMenuClose = () => setMenuOpen(false);

    React.useEffect(() => {
        if (!menuOpen) return;
        document.addEventListener('click', handleMenuClose);
        return () => document.removeEventListener('click', handleMenuClose);
    }, [menuOpen]);

    const inputStyle = {
        width: '100%', padding: '10px 14px', borderRadius: '10px',
        background: '#f8fafc', border: '1px solid #e2e8f0',
        color: '#1e293b', fontSize: '14px', fontFamily: 'inherit', outline: 'none',
        transition: 'border-color 0.2s, box-shadow 0.2s',
        boxSizing: 'border-box',
    };
    const readonlyInputStyle = { ...inputStyle, background: '#f8fafc', color: '#94a3b8', cursor: 'default' };
    const labelStyle = { display: 'block', fontSize: '12px', fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '6px' };
    const cardStyle = { background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '16px', padding: '24px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' };

    return (
        <>
            <style>{`
                @keyframes aurora1 { 0%,100%{transform:translate(0,0) scale(1);} 50%{transform:translate(40px,-30px) scale(1.06);} }
                @keyframes aurora2 { 0%,100%{transform:translate(0,0) scale(1);} 50%{transform:translate(-40px,40px) scale(0.94);} }

                .pu-input:focus { border-color: #2CCB90 !important; box-shadow: 0 0 0 3px rgba(44,203,144,0.1) !important; background: #f0fdf8 !important; }
                .pu-input::placeholder { color: #94a3b8; }
                .pu-btn-primary { background: linear-gradient(135deg, #2CCB90, #2DB8E1); border: none; border-radius: 10px;
                    color: #fff; font-weight: 700; font-size: 14px; padding: 12px 28px; cursor: pointer;
                    font-family: inherit; transition: all 0.2s; width: 100%; }
                .pu-btn-primary:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 6px 20px rgba(44,203,144,0.35); }
                .pu-btn-primary:disabled { opacity: 0.5; cursor: not-allowed; }
                .pu-menu-item { display:flex; align-items:center; gap:10px; width:100%; padding:10px 14px; border-radius:10px;
                    font-size:13px; font-weight:500; color:#64748b; background:none; border:none;
                    cursor:pointer; font-family:inherit; transition:all 0.15s; text-align:left; }
                .pu-menu-item:hover { background:#f8fafc; color:#1e293b; }
                .pu-menu-item.danger { color:#ef4444; }
                .pu-menu-item.danger:hover { background:rgba(239,68,68,0.06); }
            `}</style>

            <div style={{ minHeight: '100vh', background: '#f0faf6', fontFamily: "'Inter', -apple-system, sans-serif" }}>

                {/* NAVBAR */}
                <header style={{ position:'sticky', top:0, zIndex:50, background:'rgba(255,255,255,0.9)', backdropFilter:'blur(24px)', WebkitBackdropFilter:'blur(24px)', borderBottom:'1px solid #e2e8f0' }}>
                    <div style={{ maxWidth:'1280px', margin:'0 auto', padding:'0 24px', height:'64px', display:'flex', alignItems:'center', justifyContent:'space-between', gap:'16px' }}>
                        <div style={{ display:'flex', alignItems:'center', gap:'14px' }}>
                            <div style={{ display:'inline-flex', alignItems:'center', background:'#ffffff', borderRadius:'10px', padding:'6px 14px', boxShadow:'0 2px 8px rgba(0,0,0,0.08)', border:'1px solid #e2e8f0' }}>
                                <img src="/logo-horizontal.png" alt="Evlo" style={{ height:'26px', objectFit:'contain' }} onError={e => { e.target.style.display='none'; }} />
                            </div>
                            <button
                                onClick={() => navigate('/')}
                                style={{ display:'flex', alignItems:'center', gap:'6px', padding:'7px 14px', borderRadius:'10px', background:'#f8fafc', border:'1px solid #e2e8f0', color:'#64748b', fontSize:'13px', fontWeight:500, cursor:'pointer', fontFamily:'inherit', transition:'all 0.15s' }}
                                onMouseEnter={e => e.currentTarget.style.background='#f0fdf8'}
                                onMouseLeave={e => e.currentTarget.style.background='#f8fafc'}
                            >
                                <ArrowLeftIcon /> Voltar ao Início
                            </button>
                        </div>

                        <div style={{ position:'relative' }}>
                            <button
                                onClick={(e) => { e.stopPropagation(); setMenuOpen(!menuOpen); }}
                                style={{ display:'flex', alignItems:'center', gap:'10px', padding:'6px 12px', borderRadius:'12px', background: menuOpen ? '#f8fafc' : '#ffffff', border:'1px solid #e2e8f0', cursor:'pointer', transition:'all 0.15s', fontFamily:'inherit' }}
                            >
                                <div style={{ width:'32px', height:'32px', borderRadius:'50%', background:'linear-gradient(135deg, #2CCB90, #2DB8E1)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'12px', fontWeight:700, color:'#fff', flexShrink:0 }}>
                                    {iniciais}
                                </div>
                                <span style={{ color:'#94a3b8', transition:'transform 0.2s', transform: menuOpen ? 'rotate(180deg)' : 'none' }}><ChevronIcon /></span>
                            </button>

                            {menuOpen && (
                                <div style={{ position:'absolute', top:'calc(100% + 8px)', right:0, minWidth:'180px', background:'#ffffff', border:'1px solid #e2e8f0', borderRadius:'14px', boxShadow:'0 16px 48px rgba(0,0,0,0.12)', padding:'8px', zIndex:100 }}>
                                    <button className="pu-menu-item danger" onClick={onLogout}>
                                        <LogoutIcon /> Sair
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </header>

                {/* CONTEÚDO */}
                <main style={{ position:'relative', zIndex:1, maxWidth:'680px', margin:'0 auto', padding:'40px 24px 80px' }}>

                    {/* Page header */}
                    <div style={{ display:'flex', alignItems:'center', gap:'12px', marginBottom:'32px' }}>
                        <div style={{ width:'40px', height:'40px', borderRadius:'12px', background:'linear-gradient(135deg, rgba(44,203,144,0.2), rgba(45,184,225,0.2))', border:'1px solid rgba(44,203,144,0.2)', display:'flex', alignItems:'center', justifyContent:'center', color:'#2CCB90' }}>
                            <UserIcon />
                        </div>
                        <div>
                            <h1 style={{ margin:0, fontSize:'24px', fontWeight:800, color:'#0f172a', letterSpacing:'-0.02em' }}>Meu Perfil</h1>
                            <p style={{ margin:0, fontSize:'13px', color:'#64748b' }}>Informações da conta e segurança</p>
                        </div>
                    </div>

                    {/* Card: Informações */}
                    <div style={{ ...cardStyle, marginBottom:'20px' }}>
                        {/* Avatar + Nome + Badge */}
                        <div style={{ display:'flex', alignItems:'center', gap:'16px', marginBottom:'24px', paddingBottom:'20px', borderBottom:'1px solid #e2e8f0' }}>
                            <div style={{ width:'56px', height:'56px', borderRadius:'50%', background:'linear-gradient(135deg, #2CCB90, #2DB8E1)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'18px', fontWeight:700, color:'#fff', flexShrink:0 }}>
                                {iniciais}
                            </div>
                            <div>
                                <p style={{ margin:'0 0 4px', fontSize:'18px', fontWeight:700, color:'#0f172a' }}>{nome}</p>
                                <p style={{ margin:'0 0 6px', fontSize:'13px', color:'#64748b' }}>{emailReal}</p>
                                <span style={{ display:'inline-flex', alignItems:'center', padding:'3px 10px', borderRadius:'100px', background: perfilStyle.bg, border:`1px solid ${perfilStyle.border}`, color: perfilStyle.color, fontSize:'11px', fontWeight:700, letterSpacing:'0.05em', textTransform:'uppercase' }}>
                                    {PERFIL_LABELS[perfil] || perfil}
                                </span>
                            </div>
                        </div>

                        {/* Campos readonly */}
                        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'16px' }}>
                            <div style={{ gridColumn: clienteNome ? undefined : '1 / -1' }}>
                                <label style={labelStyle}>Nome</label>
                                <input style={readonlyInputStyle} value={nome} readOnly />
                            </div>
                            <div>
                                <label style={labelStyle}>E-mail</label>
                                <input style={readonlyInputStyle} value={emailReal} readOnly />
                            </div>
                            <div>
                                <label style={labelStyle}>Perfil de Acesso</label>
                                <input style={readonlyInputStyle} value={PERFIL_LABELS[perfil] || perfil} readOnly />
                            </div>
                            {clienteNome && (
                                <div>
                                    <label style={labelStyle}>Organização</label>
                                    <input style={readonlyInputStyle} value={clienteNome} readOnly />
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Card: Alterar Senha */}
                    <div style={cardStyle}>
                        <div style={{ display:'flex', alignItems:'center', gap:'10px', marginBottom:'20px', paddingBottom:'16px', borderBottom:'1px solid #e2e8f0' }}>
                            <div style={{ color:'#2CCB90' }}><LockIcon /></div>
                            <h2 style={{ margin:0, fontSize:'16px', fontWeight:700, color:'#0f172a' }}>Alterar Senha</h2>
                        </div>

                        <form onSubmit={handleAlterarSenha}>
                            <div style={{ display:'grid', gap:'16px', marginBottom:'20px' }}>
                                <div>
                                    <label style={labelStyle}>Nova Senha</label>
                                    <div style={{ position:'relative' }}>
                                        <input
                                            type={showNovaSenha ? 'text' : 'password'}
                                            className="pu-input"
                                            style={{ ...inputStyle, paddingRight:'44px' }}
                                            value={novaSenha}
                                            onChange={e => setNovaSenha(e.target.value)}
                                            placeholder="Mínimo 6 caracteres"
                                            required
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowNovaSenha(!showNovaSenha)}
                                            style={{ position:'absolute', right:'12px', top:'50%', transform:'translateY(-50%)', background:'none', border:'none', color:'#94a3b8', cursor:'pointer', padding:'4px', display:'flex', alignItems:'center' }}
                                        >
                                            {showNovaSenha ? <EyeOffIcon /> : <EyeIcon />}
                                        </button>
                                    </div>
                                </div>

                                <div>
                                    <label style={labelStyle}>Confirmar Nova Senha</label>
                                    <div style={{ position:'relative' }}>
                                        <input
                                            type={showConfirmar ? 'text' : 'password'}
                                            className="pu-input"
                                            style={{ ...inputStyle, paddingRight:'44px' }}
                                            value={confirmarSenha}
                                            onChange={e => setConfirmarSenha(e.target.value)}
                                            placeholder="Repita a nova senha"
                                            required
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowConfirmar(!showConfirmar)}
                                            style={{ position:'absolute', right:'12px', top:'50%', transform:'translateY(-50%)', background:'none', border:'none', color:'#94a3b8', cursor:'pointer', padding:'4px', display:'flex', alignItems:'center' }}
                                        >
                                            {showConfirmar ? <EyeOffIcon /> : <EyeIcon />}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <button type="submit" className="pu-btn-primary" disabled={isLoading}>
                                {isLoading ? 'Alterando...' : 'Alterar Senha'}
                            </button>
                        </form>
                    </div>
                </main>
            </div>
        </>
    );
};

export default PerfilUsuario;
